import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OnBoardingForm from "../../components/onboarding/OnBoardingForm";

type Props = {};

const OnBoarding = (props: Props) => {
  const navigate = useNavigate();
  const currentUser = useSelector((s: any) => s?.user?.data);
  console.log(currentUser?.user, "currentUser?.user?.salon");

  return currentUser?.user?.salon === null ? (
    <div className="flex items-center justify-center w-full h-full min-h-screen py-4 max-md:py-2">
      <OnBoardingForm />
    </div>
  ) : (
    navigate("/")
  );
};

export default OnBoarding;
